import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { getBoundingClientRect } from '../../../utils/functions';
import FixedView from "../../FixedView";
import FormViewer from "../../FormViewer";
import { getObject } from "../../../utils/useful";

class Col extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            headers: [],
            edit: [
                { title: "Rename", icon: "/assets/icons/highlighter.svg" },
                { title: "Bookmark", icon: "/assets/icons/line.3.horizontal.decrease.svg" },
            ],
            viwe: true,
        }
        this.more = React.createRef();
        this.moreOption = React.createRef();
        this.setPositionDiv = React.createRef();
    }
    componentDidMount() {
        console.log('props====', this.props)
        let mainHeaders = [...this.props.headers]
        let headers = []
        // let headersKey = Object.keys(this.props.headersData)
        // headers = headers.filter(header => headersKey.includes(header.key))
        mainHeaders.forEach(header => {
            let valid = getObject(this.props.headersData, header.key) ?? getObject(this.props.headersData, ('**files.' + header.key), 1) ?? false
            if (valid) {
                // header.information.disabled = true
                headers.push(header)
            }
        })
        this.setState({ headers, viwe: false }, () => {
            this.setState({ viwe: true })
        })

    }
    Openmoremenu = () => {
        this.more.showView();
    }

    render() {
        return (
                <div className={"single-list " } >
                    <div className="item" style={{ justifyContent: "space-between" }}>
                        <div className="flexcb flex-column h-100 w-100">
                            <p className="item-text" style={{ overflowWrap: "anywhere" }}>{this.props.taskName}</p>
                            {this.state.viwe &&
                                <div>
                                    <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.props.headersData} />
                                </div>
                            }
                        </div>

                        <div className="flexcb flex-column h-100 flexcb mld-4">
                            <button ref={el => this.moreOption = el} className='flexcc more-box br-5 p-1' onClick={() => this.Openmoremenu()}>
                                <img width={22} src="/assets/icons/more-black.svg" />
                            </button>
                            <img className="user-icon mt-3" src='\assets\icons\person-black.svg' />
                        </div>
                    </div>
                    <div>
                        <FixedView ref={el => this.more = el} nodeRef={this.moreOption} showFocus={false} topOffset={7} xOffset={140} zIndex={300}>
                            <div className='shadow-2 br-10 py-1 px-2' style={{ backgroundColor: "#fff", width: "180px" }}>
                                {this.state.edit.map((prop, index) => {
                                    // console.log('act=====', this.props.actions)
                                    return (
                                        <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5'
                                        >
                                            <img className='mrd-3 flexcc' src={prop.icon} />
                                            <p className='text-start des-color'>{prop.title}</p>
                                        </button>
                                    )
                                })}
                                {this.props.actions && Object.values(this.props.actions).map((propAct, index) => {
                                    return (
                                        <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5' onClick={() => [propAct.function(this.props.dataRow, this.props.index), this.more.hideView()]}
                                        >
                                            <p className='text-start des-color'>{propAct.label}</p>
                                        </button>
                                    )
                                })}

                                <div className='mx-2' style={{ borderTop: "1px solid #c8c8c8" }}>
                                </div>
                                <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5' >
                                    <img className='mrd-3 flexcc' src='/assets/icons/trash.svg' />
                                    <p className='text-start' style={{ color: "#EF1919" }} onClick={() => this.props.removeNewSubColumn()}>Delete section</p>
                                </button>
                            </div>
                        </FixedView>
                    </div>
                </div>
        );
    }
};

export default Col;
